<div class="treeview">
  <ul class="rootlist">
    @for (media of backup; track media) {
      <li>
        <a href="javascript:;" class="{{ (media.children.length > 0) ? 'has-child' : '' }}">{{media.name}}</a>
        <tree-list [media]="media"></tree-list>
      </li>
    }
  </ul>
</div>
